//This file contains the filters object used by the todos section 
//and the methods that act upon it.

//The filters object.
const filters = {
    searchText: '',
    hideCompleted: false
};

//Function to get filters.
const getFilters = () => filters;

//Function to update filters. The only parameter is an object 
//that can have the fields searchText and hideCompleted. If 
//present, they indicate that that note field is to be updated.
//Note: The parameter is destructured.
const updateFilters = ({searchText, hideCompleted}) => {
    //Update search text if given.
    if (typeof searchText === 'string') {
        filters.searchText = searchText;
    }

    //Update hide completed boolean if given.
    if (typeof hideCompleted === 'boolean') {
        filters.hideCompleted = hideCompleted;
    }
}

//Export functions.
export {getFilters, updateFilters};